import { IconicArrowRight } from '@insify/design-system/iconic-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { isActiveCoverage } from '../../../utils/policies';
import { ProductCard } from '../ProductCard';

import styles from './ProductSleeve.module.css';

import type { Bundle, CompanyBundle, PersonalBundle } from '../../../types/Policy';

/**
 * Outer sleeve component displayed within the product list
 * @param bundle - product details
 */
const ProductSleeve: React.FC<Bundle> = (bundle) => {
  const { t } = useTranslation('policy');
  const navigate = useNavigate();

  const bundleCoverage = bundle.coverages[0];
  const isActive = isActiveCoverage(bundleCoverage);

  const navigateToProductDetail = () => {
    navigate(`/products/${bundle.id}`);
  };

  return (
    <div
      data-hj-suppress
      className={styles.itemCard}
      onClick={navigateToProductDetail}
      onKeyUp={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          navigateToProductDetail();
        }
      }}
    >
      <div className={styles.innerCardContainer}>
        <ProductCard className={styles.inner} bundle={bundle} />
      </div>
      <div className={styles.pouch}></div>
      <div className={styles.cardContent}>
        <div className={styles.titleArea}>
          <p className={styles.itemType}>{t(`policy_type.${bundle.type === 'company' ? 'pnc' : 'disability'}`)}</p>
          <h3 className={styles.itemTitle}>
            {bundle.type === 'company' ? (bundle as CompanyBundle).companyName : (bundle as PersonalBundle).name}
          </h3>
        </div>
        <div className={styles.statusArea}>
          {/* FIXME: we need to converge statuses from i2go & socotra and minimize reflected cases */}
          <span className={`${styles.status} ${isActive ? styles.active : styles.inactive}`}>
            {isActive ? t('active') : t('inactive')}
          </span>
          <span className={styles.arrow}>
            <IconicArrowRight />
          </span>
        </div>
      </div>
    </div>
  );
};

export { ProductSleeve };
